import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8670d40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b8670d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8670d40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserInfoBox: require('/drone/src/components/UserInfoBox/index.vue').default,OrderBoxSell: require('/drone/src/components/OrderBox/OrderBoxSell.vue').default,OrderBoxNew: require('/drone/src/components/OrderBox/OrderBoxNew.vue').default,OrderBoxBuyer: require('/drone/src/components/OrderBox/OrderBoxBuyer.vue').default,CollectionBox: require('/drone/src/components/CollectionBox/index.vue').default,BargainSuccessTips: require('/drone/src/components/Bargain/success-tips/index.vue').default})
